import { createFileRoute, redirect } from '@tanstack/react-router';

/** The old address of the new-invoice form. See `financial.invoices.$ref.tsx`. */
export const Route = createFileRoute('/financial/invoices/new')({
  beforeLoad: () => {
    throw redirect({ to: '/bills/invoices/new', replace: true });
  },
});
